import {sample} from 'effector';
import {combine, merge} from 'effector/effector.cjs';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    data$,
    defaultFilters,
    defaultSortings,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    search$,
    searchChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
} from './index';

pageNumber$.reset(filtersChanged, sortingsChanged, stateReset);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);

sample({
    clock: merge([tableStateChanged, searchChanged, Gate.open]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
        searchField: search$,
    }),
    fn: ({pageNumber, pageSize, filters, sortings, searchField}) => ({
        paging: {pageNumber, pageSize},
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        searchField,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
